// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2iieX","delete":"styles_delete__3uPBo","update":"styles_update__2x9to","add":"styles_add__2vOrL"};